"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _Label = _interopRequireDefault(require("@cimpress/react-components/lib/Label"));

var _colors = require("@cimpress/react-components/lib/colors");

var _textWrapTag = _interopRequireDefault(require("./textWrapTag"));

var _formulaString = _interopRequireDefault(require("./formulaString"));

var _propTypes2 = require("./propTypes");

var _messages = _interopRequireDefault(require("./messages"));

var _operatorMessages = _interopRequireDefault(require("./messages/operatorMessages"));

var _rangeTranslator = require("./formatters/rangeTranslator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 5px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: min-content auto;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: 50% 50%;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: min-content auto;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 5px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var gridDisplay = (0, _emotion.css)(_templateObject());
var layouts = {
  resultOnly: (0, _emotion.css)(_templateObject2()),
  singleResult: (0, _emotion.css)(_templateObject3()),
  ruleConstraint: (0, _emotion.css)(_templateObject4()),
  ruleConstraintContents: (0, _emotion.css)(_templateObject5())
};
var smallMarginTop = (0, _emotion.css)(_templateObject6()); // If attribute name is omitted, also omit operator -- property assignment case

var SingleConditionDisplay = function SingleConditionDisplay(_ref) {
  var attribute = _ref.attribute,
      operator = _ref.operator,
      values = _ref.values;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return (
    /*#__PURE__*/
    _react["default"].createElement("span", null, attribute &&
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_Label["default"], {
      type: "info",
      text: attribute
    }), " ", operator ? formatMessage(_operatorMessages["default"][operator]) : null, ' '), values && values.map(function (value) {
      return value.formula ?
      /*#__PURE__*/
      _react["default"].createElement(_textWrapTag["default"], {
        style: {
          margin: '3px',
          backgroundColor: _colors.silver
        },
        key: value.formula,
        value:
        /*#__PURE__*/
        _react["default"].createElement(_formulaString["default"], null, value.formula)
      }) :
      /*#__PURE__*/
      _react["default"].createElement(_textWrapTag["default"], {
        style: {
          margin: '3px'
        },
        key: value.range ? JSON.stringify(value.range) : value.value,
        value: value.range ? formatMessage((0, _rangeTranslator.getRangeMessage)(value.range), value.range) : value.value
      });
    }))
  );
};

SingleConditionDisplay.propTypes = {
  attribute: _propTypes["default"].string,
  operator: _propTypes["default"].string,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};

var RuleDisplay = function RuleDisplay(_ref2) {
  var conditions = _ref2.conditions,
      resultAttribute = _ref2.resultAttribute,
      result = _ref2.result,
      results = _ref2.results;

  var _useIntl2 = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl2.formatMessage;

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(gridDisplay, results ? layouts.ruleConstraint : conditions ? layouts.singleResult : layouts.resultOnly)
    }, result ?
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement(SingleConditionDisplay, {
      attribute: resultAttribute,
      operator: 'in',
      values: [result]
    })) : null, conditions ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(gridDisplay, layouts.ruleConstraintContents)
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: smallMarginTop
    }, result ? formatMessage(_messages["default"].when) : formatMessage(_messages["default"]["if"])),
    /*#__PURE__*/
    _react["default"].createElement("div", null, conditions.map(function (condition) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          key: JSON.stringify(condition)
        },
        /*#__PURE__*/
        _react["default"].createElement(SingleConditionDisplay, {
          attribute: condition.attribute,
          operator: condition.operator,
          values: condition.values
        }))
      );
    }))) : null, results ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(gridDisplay, layouts.ruleConstraintContents)
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: smallMarginTop
    }, formatMessage(_messages["default"].then)),
    /*#__PURE__*/
    _react["default"].createElement("div", null, results.map(function (result) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          key: JSON.stringify(result)
        },
        /*#__PURE__*/
        _react["default"].createElement(SingleConditionDisplay, {
          attribute: result.attribute,
          operator: result.operator,
          values: result.values
        }))
      );
    }))) : null)
  );
};

RuleDisplay.propTypes = {
  conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintConditionShape)),
  result: _propTypes["default"].shape(_propTypes2.constraintConditionShape),
  results: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintConditionShape)),
  resultAttribute: _propTypes["default"].string
};
var _default = RuleDisplay;
exports["default"] = _default;